import { addThousandsSeparatorToString } from './addThousandsSeparatorToString';

export const addThousandsSeparator = (num: number): string =>
    addThousandsSeparatorToString(num.toString());
